import {FadeInBody} from "./components/FadeInBody";
import {Nav} from "./components/Nav";
import {FirstView} from "./components/FirstView";
import {VenueDetails} from "./components/VenueDetails";
import {Program} from "./components/Program";
import {PageTopBtn} from "./components/PageTopBtn";
import {Footer} from "./components/Footer";

export const App = () => {
  return (
    <FadeInBody>
      <Nav />
      <main>
        <FirstView />
        <VenueDetails />
        <Program />
      </main>
      <PageTopBtn />
      <Footer />
    </FadeInBody>
  );
};
